import React, { ReactElement, useEffect, useState } from 'react';
import TooltipContent from 'atomic/tooltip/tooltip-content';

import './tooltip.scss';

const TooltipComponent = React.lazy(() => import('react-tiny-popover').then(mod => ({ default: mod.Popover })));

export interface TooltipProps {
    positions?: ('right' | 'top' | 'left' | 'bottom')[];
    title: JSX.Element;
    trigger: JSX.Element;
}

const Tooltip: React.FC<TooltipProps> = ({ title, positions = ['right', 'top', 'left', 'bottom'], trigger, children }): ReactElement => {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [clientside, setClientside] = useState(false);

    useEffect(() => setClientside(true), []);

    return (
        clientside
            ? (
                <React.Suspense fallback={trigger}>
                    <TooltipComponent
                        isOpen={tooltipOpen}
                        content={<TooltipContent title={title} onClose={(): void => setTooltipOpen(false)}>
                            {children}
                        </TooltipContent>}
                        positions={positions}
                        onClickOutside={(): void => setTooltipOpen(false)}
                        align={'start'}
                        containerStyle={{ zIndex: '1000' }}
                    >
                        {
                            React.cloneElement(trigger, { onClick: () => setTooltipOpen(!tooltipOpen) })
                        }
                    </TooltipComponent>
                </React.Suspense>
            )
            : trigger
    );
};

export default Tooltip;
